import { Switch as MaterialSwitch } from '@mui/material'

const Switch = MaterialSwitch

export { Switch }
